import "../vendor/select2.min.js";
import { each } from "jquery";

var netwerkFilter = {};

netwerkFilter.init = function () {
  initSelects();

  $(".filter__switch input").change(function () {
    $(".current-page").html("1");
    getItems();
    tabState();
  });

  tabState();
  addEventListeners();
  anchorLinks();
  updatePagination();
};

function anchorLinks() {
	if (location.search !== "") {
	  let queryParams = new URLSearchParams(window.location.search);
	  if (queryParams.has("netwerk")) {
		 let netwerk = decodeURI(queryParams.get("netwerk"));

		 if (netwerk !== undefined) {
			document.querySelector("#bureau-freelancer-filter").scrollIntoView({ behavior: "smooth" });
			if (netwerk !== "bureau") {
			  document.querySelector(`label.label_${netwerk}`).click();
			}
		 }
	  }
	}

  document.querySelectorAll(".label_anchor").forEach((el) => {
    el.addEventListener("click", (e) => {
      const urlParams = new URLSearchParams();
      urlParams.set("netwerk", encodeURI(el.dataset.label));
      history.replaceState(null, null, "?" + urlParams.toString());
    });
  });
}

function getItems(change) {
  // var elem = e.target.id;
  var currentState = $(".filter__switch").find("input:checked").val();
  var action = "get_freelancers";
  if (currentState === "bureau") {
    action = "get_bureaus";
  }
  var selected;
  var filterObj = {
    action: action,
  };

  $(".filter__options select").each(function () {
    if ($(this).val()) {
      filterObj[$(this).attr("name")] = $(this).val();
    }
  });
  filterObj["page"] = parseInt($(".current-page").html());
  filterObj["change"] = change;
  $.ajax({
    method: "post",
    url: customData.ajaxURL,
    data: filterObj,
    dataType: "json",
    beforeSend: function () {
      $(".filter__options .filter-items__container").css("opacity", 0.5);
    },
    success: function (response) {
      $('.filter-items__container[data-state="' + currentState + '"]')
        .removeAttr("style")
        .html(response.items);
      destroySelects();
      $(".filter__dropdowns").html(response.selects_html);
      initSelects();
      updatePagination(response);
      addEventListeners();
      $("body").icons.init(".svg-icon");
      window.lazy.update();
      document.getElementById("bureau-freelancer-filter").scrollIntoView({ behavior: "smooth" });
    },
  });
}

function initSelects() {
  $(".filter__dropdown.select2").each(function () {
    $(this).select2({
      dropdownAutoWidth: true,
      minimumResultsForSearch: Infinity,
      allowClear: true,
    });
  });
}
function destroySelects() {
  $(".filter__dropdown.select2").each(function () {
    $(this).select2("destroy");
  });
}

function addEventListeners() {
  var change;
  $(".select2").each(function () {
    $(this).on("change", function (e) {
      change = $(this).attr("name");
    });
    $(this).on("select2:select", function () {
      $(".current-page").html("1");
      getItems(change);

      $(this).on("select2:opening.cancelOpen", function (evt) {
        evt.preventDefault();
        $(this).off("select2:opening.cancelOpen");
      });
    });

    $(this).on("select2:opening", function (evt) {
      var currentSelection = $(this).select2("data");
      if (currentSelection[0] && currentSelection[0].text) {
        evt.preventDefault();
      }
    });
  });

  $(".select2").each(function () {
    $(this).on("select2:clear", function (e) {
      $(".current-page").html("1");
      getItems();

      //cancels the dropdown when trying to clear
      $(this).on("select2:opening.cancelOpen", function (evt) {
        evt.preventDefault();
        $(this).off("select2:opening.cancelOpen");
      });
    });
  });

  $(".js-next")
    .unbind("click")
    .on("click", function (e) {
      var current = parseInt($(".current-page").html());
      var total = parseInt($(".total-pages").html());
      var next = current + 1;
      if (next <= total) {
        $(".current-page").html(next);
        getItems();
      }
    });
  $(".js-prev")
    .unbind("click")
    .on("click", function (e) {
      var current = parseInt($(".current-page").html());
      var prev = current - 1;
      if (prev >= 1) {
        $(".current-page").html(prev);
        getItems();
      }
    });
}

function updatePagination(response) {
  if ("undefined" == typeof response) {
    if ($(".total-pages").html() === "1") {
      $(".js-next").hide();
      $(".js-prev").hide();
      return;
    }
  }
  if (response.pages == 0) {
    $(".pagination").hide();
  } else {
    $(".total-pages").html(response.pages);
    $(".pagination").show();
  }
  if ($(".current-page").html() === $(".total-pages").html()) {
    $(".js-next").hide();
  } else {
    $(".js-next").show();
  }
  if ($(".current-page").html() > 1) {
    $(".js-prev").show();
  } else {
    $(".js-prev").hide();
  }
}

function tabState() {
  var currentState = $(".filter__switch").find("input:checked").val();
  $("[data-state]").hide();
  $('[data-state="' + currentState + '"]').show();
  if (currentState === "freelancer") {
    $("body").icons.init(".svg-icon");
  }
}

export { netwerkFilter };
